export const isMobileDevice = () => {
  let result = false;

  const toMatch = [
    /Android/i,
    /webOS/i,
    /iPhone/i,
    /iPad/i,
    /iPod/i,
    /BlackBerry/i,
    /Windows Phone/i,
  ];

  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < toMatch.length; i++) {
    if (navigator.userAgent.match(toMatch[i])) {
      result = true;
      break;
    }
  }

  return result;
};
